import store from "../../services/store.js";
export default {
  store,
  name: "MessageModal",
  props: {
    useSubButton: {
      type: Boolean,
      default: false
    },
    subButtonMessage: {
      type: String,
      default: ""
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getTitle: function () {
      return this.settings && this.settings.title ? this.settings.title : this.$store.state.title;
    },
    getMessage: function () {
      return this.settings && this.settings.message ? this.settings.message : this.$store.state.message;
    }
  }
};